import React, { useState, useRef, useEffect } from 'react';

function BoardAnchorPopup({ replyNumber, content, authorName, createdAt, children }) {
  const [isVisible, setIsVisible] = useState(false);
  const popupRef = useRef(null);
  const triggerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        popupRef.current &&
        !popupRef.current.contains(event.target) &&
        triggerRef.current &&
        !triggerRef.current.contains(event.target)
      ) {
        setIsVisible(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <span style={{ position: 'relative', display: 'inline' }}>
      <span
        ref={triggerRef}
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
        style={{ color: 'var(--ch-anchor)', cursor: 'pointer', textDecoration: 'underline' }}
      >
        {children}
      </span>
      {isVisible && (
        <div
          ref={popupRef}
          onMouseEnter={() => setIsVisible(true)}
          onMouseLeave={() => setIsVisible(false)}
          style={{
            position: 'absolute',
            zIndex: 50,
            width: '320px',
            backgroundColor: 'var(--ch-bg-post)',
            border: '1px solid var(--ch-border)',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            padding: '8px',
            top: '20px',
            left: 0,
          }}
        >
          <div style={{ fontSize: '11px', color: 'var(--ch-muted)', marginBottom: '4px' }}>
            {replyNumber} {authorName} {createdAt}
          </div>
          <div style={{ fontSize: '13px', color: 'var(--ch-text)', whiteSpace: 'pre-wrap' }}>
            {content}
          </div>
        </div>
      )}
    </span>
  );
}

export default BoardAnchorPopup;
